import { render, staticRenderFns } from "./ProdutoFiltro.vue?vue&type=template&id=087105be&"
import script from "./ProdutoFiltro.vue?vue&type=script&lang=js&"
export * from "./ProdutoFiltro.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoFiltro.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports